import { renderToHTML } from "common";
import { jsx as _jsx } from "react/jsx-runtime";
export function Detail(props) {
  return /*#__PURE__*/_jsx("p", {
    dangerouslySetInnerHTML: {
      __html: renderToHTML(props.text.replace(/\n/g, "\n\n"))
    },
    className: "prose-pre:whitespace-pre-wrap text-blue-800 text-md prose prose-h1:text-lg prose-h2:text-base prose-h3:text-base prose-a:text-blue-600 max-w-full",
    "data-testid": props.testID
  });
}